import axios, { CancelTokenSource } from 'axios';
import { EmailCampaignDto, UpsertEmailCampaignDto } from 'ts-types/api.types';

const {REACT_APP_API_BASE_URL: baseUrl} = process.env;
const apiUri = `${baseUrl}/api/email-broadcast/campaign`;

export const getActiveEmailCampaigns = (
    source: CancelTokenSource): Promise<EmailCampaignDto[]> => {

  return getEmailCampaigns(false, source);
}

export const getEmailCampaigns = (
    includingInactive: boolean = false,
    source: CancelTokenSource): Promise<EmailCampaignDto[]> => {

  return axios
      .get(`${apiUri}`, {
        params: {
          includingInactive: includingInactive
        },
        cancelToken: source.token
      })
      .then(response => response.data);
}

export const getCampaign = (
    id: number, source: CancelTokenSource): Promise<UpsertEmailCampaignDto> => {

  return axios
      .get(`${apiUri}/${id}`, {cancelToken: source.token})
      .then(response => response.data);
}

export const addCampaign = (
    request: Partial<UpsertEmailCampaignDto>,
    source: CancelTokenSource): Promise<UpsertEmailCampaignDto> => {

  return axios
      .post(apiUri, request, {cancelToken: source.token})
      .then(response => response.data)
}

export const editCampaign = (
    id: number,
    request: Partial<UpsertEmailCampaignDto>,
    source: CancelTokenSource): Promise<UpsertEmailCampaignDto> => {

  return axios
      .put(`${apiUri}/${id}`, request, {cancelToken: source.token})
      .then(response => response.data)
}

export const deleteCampaign = (
    id: number, source: CancelTokenSource): Promise<EmailCampaignDto> => {

  return axios
      .delete(`${apiUri}/${id}`, {cancelToken: source.token})
      .then(response => response.data);
}
